module.exports = __webpack_public_path__ + "static/media/money.86666074.png";